import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import app from './config';

const db = getFirestore(app);

// Opt-in, nur wenn explizit gesetzt (z.B. `REACT_APP_USE_EMULATORS=true npm start`) -
// Standardverhalten (Produktion) bleibt unverändert. Siehe docs/firebase-setup.md.
if (process.env.REACT_APP_USE_EMULATORS === 'true') {
  connectFirestoreEmulator(db, 'localhost', 8080);
}

export default db;
